
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/commerce-law",
      function () {
        return require("private-next-pages/commerce-law/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/commerce-law"])
      });
    }
  